import Vue from 'vue';
if (document.getElementById('event-page')) {
    let event = new Vue({
        el: '#event-page',
        data: {
            tickets: tickets,
            event: {},
            page: 1,
            pageCount: 0,
            boughtCount: []
        },
        methods: {
            bought: function () {
                for (var index in this.tickets) {
                    var item = this.tickets[index];
                    if (item.is_bought === true) {
                        this.boughtCount.push(item)
                    }
                }
            }
        },
        created: function () {
            this.bought()
        },
        computed: {
            filterTickets: function () {
                var arr = [];
                var self = this;
                for(var i in self.tickets) {
                    var item = self.tickets[i];
                    if (item.is_active === true) {
                        arr.push(item)
                    }

                }
                return arr
            }
        }
        

    });
}